import type { VFC } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";
import commonStyles from "./ProfileHeader.module.scss";
import unauthenticatedStyles from "./ProfileHeaderUnauthenticated.module.scss";
import classnames from "classnames";
import { SearchParam } from "@/enums/search-param.enum";
import { PROFILE_SIGN_IN_ROUTE } from "@/constants/routes.constant";

export const ProfileHeaderUnauthenticated: VFC = () => {
  const { t, lang } = useTranslation("web-payments");
  const router = useRouter();

  const query = new URLSearchParams({
    [SearchParam.Redirect]: `${lang}${router.asPath}`,
    [SearchParam.Origin]: "profile",
  });

  return (
    <header className={commonStyles.wrapper}>
      <ImageWithFallback
        className={commonStyles.iconContainer}
        width={48}
        height={48}
        fallbackImage={null}
        alt=""
        src="https://images.onefootball.com/cw/icons/profile-light.svg"
        darkModeSrc="https://images.onefootball.com/cw/icons/profile-dark.svg"
      />

      <p
        className={classnames(
          commonStyles.title,
          unauthenticatedStyles.profileText,
        )}
      >
        {t`PROFILE`}
      </p>

      <div className={commonStyles.subtitle}>
        <Link
          href={`${PROFILE_SIGN_IN_ROUTE}?${query.toString()}`}
          passHref={true}
          className={unauthenticatedStyles.link}
        >
          {t`LOGIN_CTA_SIGN_IN`}
        </Link>
      </div>
    </header>
  );
};
